module.exports = __webpack_public_path__ + "img/fundingContainer1Model.6d5f6721.png";